import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "main-search",
  "use": "main-search-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"main-search\"><path d=\"M8.85 13.692h.768l.272-.263a6.29 6.29 0 01-1.526-4.111 6.318 6.318 0 116.318 6.318 6.29 6.29 0 01-4.111-1.526l-.263.272v.768L5.448 20 4 18.552l4.85-4.86zm5.832 0a4.368 4.368 0 004.374-4.374 4.368 4.368 0 00-4.374-4.374 4.368 4.368 0 00-4.374 4.374 4.368 4.368 0 004.374 4.374z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol